import Util from '@/lib/util'
import AppConsts from '@/lib/appconst'
export default [
    {
        title:Util.L('Order'),
        key:'orderNo'
    },
    {
        title:Util.L('SKU'),
        key:'sku'
    },{
        title:Util.L('ProductName'),
        key:'productName'
    },{
        title:Util.L('Qty'),
        width:100,
        slot: 'orderQty',
        
    },{
        title:Util.L('ProductPrice'),
        width:100,
        align:'right',
        key:'productPrice',
        render:(h:any,params:any)=>{
            return h("span", Util.toViewNumberString(params.row.productPrice));
        }
        
    },{
        title:Util.L('Price'),
        width:100,
        slot: 'price',
        
    },{
        title:Util.L('VATPercent'),
        width:100,
        slot: 'vatPercent',
        
    }
    ,{
        title:Util.L('AssetType'),
        key:'assetTypeCode',
        render:(h:any,params:any)=>{
            return h("span", Util.L(AppConsts.prefixConsts.assetType+ params.row.assetTypeCode));
        }
    }
    ,{
        title:Util.L('ConditionType'),
        key:'conditionTypeCode',
        render:(h:any,params:any)=>{
            return h("span", Util.L(AppConsts.prefixConsts.conditionType+ params.row.conditionTypeCode));
        }
    } ,{
        title:Util.L('Action'),
        width:80,
        slot: 'action',
    }]